import { useCallback, useContext, useEffect, useState } from "react";
import { Checkbox, Table, Loader, Modal } from "rsuite";
import { useDispatch, useStore } from "react-redux";
import { IoIosCheckmarkCircleOutline, IoIosSend, IoMdArrowRoundBack } from "react-icons/io";
import { RiDraftFill } from "react-icons/ri";

import { AppContext } from "../../../context";
import { checkIsAdminOrModerator } from "../../../services/helper";
import openMailImg from "../../../assets/img/open-mail.png"
import unreadMail from "../../../assets/img/unread-mail.png"
import forward from "../../../assets/img/forward.png"
import reply from "../../../assets/img/reply.png"
import deleteImg from "../../../assets/img/delete.png"
import { deleteEmailFromTask, getDraftEmailsForMicrosoft, getDraftEmailsFromGoogle, getEmailCountsForGoogle, getEmailCountsForMicrosoft, getEmailDetailsForThreadId, getEmailListForUser, getEmailsForAuthGoogleUser, getJunkEmailsForMicrosoft, getMicrosoftTokenAndEmails, getSentEmailsFromGoogle, getSentEmailsFromMicrosoft, getSpamEmailsFromGoogle } from "../../../redux/actions/emailSettings";
import { toast } from "../../CommonComponents/ToastComponent/toast";
import Accordion from "../../CommonComponents/Accordion";
import ComposeEmail from "../../ComposeEmail";
import LoaderComponent from "../../CommonComponents/LoaderComponent";
import EmailDetail from "./emailDetail";
import EmailDraft from "./emailDraft";

const { Column, HeaderCell, Cell } = Table

const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0, display: 'flex', alignItems: 'center', margin: 0 }}>
        <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some(item => item === rowData[dataKey])} />
    </Cell>
);

export const TableCell = ({ rowData, dataKey, selectedMailAndCategory, onPageChange, type = 'string', ...props }) => {
    let sender = ''
    let date = ''

    if (dataKey === 'sender') {
        if (selectedMailAndCategory?.category === "sent") {
            sender = rowData?.receiverEmail
        } else if (selectedMailAndCategory?.category === "inbox" || selectedMailAndCategory?.category === "junk") {
            sender = rowData?.senderEmail
        }

        return (
            <Cell {...props} className="table-link" onClick={() => { onPageChange(rowData?.messageId) }}>
                <p>{sender}</p>
            </Cell>
        )
    } else if (dataKey === "bodyPreview") {
        if (selectedMailAndCategory?.category === 'drafts') {
            return (
                <Cell {...props} className="table-link" onClick={() => { onPageChange(rowData?.messageId) }}>
                    <p >{rowData?.body}</p>
                </Cell>
            )
        } else {
            return (
                <Cell {...props} className="table-link" onClick={() => { onPageChange(rowData?.messageId) }}>
                    <p >{rowData?.subject}</p>
                </Cell>
            )
        }


    } else if (dataKey === "date") {
        if (selectedMailAndCategory?.category === 'sent') {
            date = rowData?.sentDate
        } else {
            date = rowData?.receivedDate
        }

        return (
            <Cell {...props} className="table-link" onClick={() => { onPageChange(rowData?.messageId) }}>
                <p >{date}</p>
            </Cell>
        )
    }
}

const ActionCell = ({ rowData, onDeleteEmail, selectedMailAndCategory, dataKey, actionHandler, currentPage, ...props }) => {
    if (dataKey === 'isRead') {
        return (
            <Cell {...props} className="table-content-action justify-content-start" style={{ padding: '6px', display: 'flex', alignItems: 'center' }}>
                <div class="d-flex align-items-center justify-content-center">
                    {rowData?.isRead && <button><IoIosCheckmarkCircleOutline size={28} color="#65B3E9" /></button>}
                </div>
            </Cell>
        )
    } else if (dataKey === 'delete') {
        return (
            <Cell {...props} className="table-content-action justify-content-start" style={{ padding: '6px', display: 'flex', alignItems: 'center' }}>
                <div class="d-flex align-items-center justify-content-center">
                    <button onClick={() => { onDeleteEmail(rowData?.messageId) }}><img src={deleteImg} /></button>
                </div>
            </Cell>
        )
    } else if (dataKey === 'reply') {
        return (
            <Cell {...props} className="table-content-action justify-content-start" style={{ padding: '6px', display: 'flex', alignItems: 'center' }}>
                <div class="d-flex align-items-center justify-content-center">
                    <button onClick={() => { actionHandler(rowData?.messageId, dataKey) }}><img src={reply} /></button>
                </div>
            </Cell>
        )
    } else if (dataKey === 'forward') {
        return (
            <Cell {...props} className="table-content-action justify-content-start" style={{ padding: '6px', display: 'flex', alignItems: 'center' }}>
                <div class="d-flex align-items-center justify-content-center">
                    <button onClick={() => { actionHandler(rowData?.messageId, dataKey) }}><img src={forward} /></button>
                </div>
            </Cell>
        )
    }
    return (
        <Cell {...props} className="table-content-action justify-content-start" style={{ padding: '6px', display: 'flex', alignItems: 'center' }}>
            <div class="d-flex align-items-center justify-content-center">
                {rowData?.isOpen && <button><IoIosCheckmarkCircleOutline size={28} color="#65B3E9" /></button>}
            </div>
        </Cell>
    )
}


const Emails = ({ tab, currentPage, setCurrentPage }) => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        convertEmailHistoryStructure,
        unreadEmails
    } = useContext(AppContext);
    const {
        emailSettings,
        domain
    } = store

    const { currentDomain } = domain
    const isAdminOrModerator = checkIsAdminOrModerator(currentDomain)
  
    const [emailList, setEmailList] = useState([]) //inbox emails
    const [isLoading, setIsLoading] = useState(false)
    const [selectedEmail, setSelectedEmail] = useState({})
    const [userEmails, setUserEmails] = useState([])
    const [selectedUserMail, setSelectedUserEmail] = useState({}) //user emails
    const [prevbtn, setPrevBtn] = useState(false)
    const [nextBtn, setNextBtn] = useState(false)
    const [checkedKeys, setCheckedKeys] = useState([]);
    const [activeEmail, setActiveEmail] = useState(null)
    const [activeSection, setActiveSection] = useState('')
    const [isLoadingUserEmails, setIsLoadingUserEmails] = useState(false)
    const [totalJunksRecords, setTotalJunksRecords] = useState(0)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [emailIdToDelete, setEmailIdToDelete] = useState(null)
    const [showEmailComposeModal, setShowEmailComposeModal] = useState(false)
    const [action, setAction] = useState('')
    const [formattedEmailList, setFormattedEmailList] = useState([])
    const [selectedFormatedEmail, setSelectedFormatedEmail] = useState({})
    const [noRegEmailModal, setNoRegEmailModal] = useState(false)

    const [forwardOrReplyEmailId, setForwardOrReplyEmailId] = useState(null)
    const [selectedMailAndCategory, setSelectedMailAndCategory] = useState({
        email: '',
        category: '',
        domain: '',
        id: ''
    })

    const sideBar = [
        { id: 'inbox', name: 'Inbox', icon: <IoIosSend size={18} color="#214466" /> },
        { id: 'sent', name: 'Sent', icon: <IoIosSend size={18} color="#214466" /> },
        { id: 'drafts', name: 'Drafts', icon: <RiDraftFill size={18} color="#214466" /> },
        { id: 'junk', name: 'Junks', icon: <RiDraftFill size={18} color="#214466" /> }
    ]

    const columns = [
        { name: 'sender', label: 'Sender' },
        { name: 'bodyPreview', label: 'Body Review' },
        { name: 'date', label: 'Date' },
    ]

    const emailButtons = [
        { label: 'openMailImg', value: openMailImg },
        { label: 'unreadMail', value: unreadMail },
        { label: 'forward', value: forward },
        { label: 'reply', value: reply },
        { label: 'deleteImg', value: deleteImg },
    ]

    let checked = false;
    let indeterminate = false;

    if (checkedKeys?.length === formattedEmailList?.length) {
        checked = true;
    } else if (checkedKeys.length === 0) {
        checked = false;
    } else if (checkedKeys.length > 0 && checkedKeys.length < formattedEmailList.length) {
        indeterminate = true;
    }

    const handleCheckAll = (value, checked) => {
        const keys = checked ? formattedEmailList.map(item => item.id) : [];
        setCheckedKeys(keys);
    };
    const handleCheck = (value, checked) => {
        const keys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);
        setCheckedKeys(keys);
    };

    const headerColumns = () => {
        return columns.map((col) => {
            if (selectedMailAndCategory?.category === 'drafts' && col.name === 'bodyPreview') {
                return (
                    <Column
                        resizable
                        sortable={true}
                        key={col.name}
                        width={150}
                    >
                        <HeaderCell className='text-black mb-0 fw-bold'>{'Draft'}</HeaderCell>
                        <TableCell dataKey={col.name} onPageChange={onPageChange} selectedMailAndCategory={selectedMailAndCategory} />
                    </Column>
                )
            } else if (selectedMailAndCategory?.category !== 'drafts') {
                let headerName = ''
                if (selectedMailAndCategory?.category === 'inbox' || selectedMailAndCategory?.category === 'junk') {
                    headerName = col?.name === 'sender' ? 'Sender' : col?.name === 'date' ? 'Received Date' : 'Subject'
                } else if (selectedMailAndCategory?.category === 'sent') {
                    headerName = col?.name === 'sender' ? 'Receiver' : col?.name === 'date' ? 'Sent Date' : 'Subject'
                }
                return (
                    <Column
                        resizable
                        sortable={true}
                        key={col.name}
                        width={col?.name === 'sender' ? 150 : ''}
                        flexGrow={col?.name === 'sender' ? 0 : 1}
                    >
                        <HeaderCell className='text-black mb-0 fw-bold'>{headerName}</HeaderCell>
                        <TableCell dataKey={col.name} onPageChange={onPageChange} selectedMailAndCategory={selectedMailAndCategory} />
                    </Column>
                )
            }
        })
    }

    const onPageChange = (id) => {
        let selectedEmail = formattedEmailList.filter((detail) => detail?.messageId === id)
        setSelectedEmail(selectedEmail[0])
        if (tab === 'notifications') {
            setCurrentPage('notification-email')
        } else if (tab === 'emails') {
            if (currentPage === 'draft') {
                setCurrentPage('draftEmail')
            } else {
                setCurrentPage('emailDetail')
            }
        }
    }

    const onGetGoogleEmails = async (accessToken, refreshToken, email, pageToken = null, btn, emailSyncDuration) => {
        setIsLoading(true)
        dispatch(getEmailsForAuthGoogleUser({ accessToken, refreshToken, email, pageToken, btn, emailSyncDuration })).then(async (res) => {
            if ('nextPageToken' in res?.data) {
                setNextBtn(false)
            } else {
                setNextBtn(true)
            }

            if (emailSettings?.currentPage === 1) {
                setPrevBtn(true)
            } else {
                setPrevBtn(false)
            }

            let allEmailDetails = []
            for (let i = 0; i < res?.data?.messages?.length; i++) {
                await dispatch(getEmailDetailsForThreadId({ accessToken, messageIds: [res?.data?.messages[i]?.id], email, refreshToken, inChunks: false })).then((res) => {
                    let unReadIndex = res?.data?.labelIds?.findIndex((label) => label === 'UNREAD')
                    allEmailDetails.push({ ...res?.data, isRead: unReadIndex === -1 ? true : false })
                }).catch(err => {
                    toast.show({
                        title: 'Warning',
                        description: 'Unable To Get Email Details',
                    })
                })
            }

            setIsLoading(false)
            setEmailList(allEmailDetails)
        }).catch(err => {
            if (err === 'Network Error') {
                toast.show({
                    title: 'Warning',
                    description: 'Please Check Your Network Connectivity And Retry',
                })
                return
            }
            setIsLoading(false)
            setEmailList([])
            if (err === 401) {
                toast.show({
                    title: 'Warning',
                    description: 'Please authenticate again',
                })
            }
        })
    }

    const onGetMicrosoftEmails = (accessToken, selectedEmail, pageLink = null, btn, emailSyncDuration) => {
        setIsLoading(true)
        dispatch(getMicrosoftTokenAndEmails({ accessToken, selectedEmail, pageLink, btn, emailSyncDuration })).then((res) => {
            setIsLoading(false)
            setEmailList(res?.emails)
            if (emailSettings?.microsoftCurrentPage === 1) {
                setPrevBtn(true)
            } else {
                setPrevBtn(false)
            }

            if (res?.nextPageLink === '') {
                setNextBtn(true)
            } else {
                setNextBtn(false)
            }
        }).catch(async (err) => {
            setIsLoading(false)
            setEmailList([])
            toast.show({
                title: 'Warning',
                description: 'Error Occured While Fetching User Emails',
            })
        })
    }

    const getEmailsForUser = useCallback(async (cancelled) => {
        if (cancelled) {
            return
        }
        setIsLoadingUserEmails(true)
        dispatch(getEmailListForUser()).then(async (res) => {
            if (res?.length === 0) {
                setNoRegEmailModal(true)
            } else {
                setNoRegEmailModal(false)
            }

            const msEmails = res?.filter(data => data?.domain === 'microsoft')
            const googleEmails = res?.filter(data => data?.domain === 'google')

            if (msEmails?.length > 0) {
                for (let i = 0; i < msEmails?.length; i++) {
                    await dispatch(getEmailCountsForMicrosoft({ email: msEmails[i]?.email, accessToken: msEmails[i]?.accessToken, emailSyncDuration: msEmails[i]?.emailSyncDuration })).then((countRes) => {
                        if (msEmails[i].email === countRes?.email) {
                            msEmails[i]['drafts'] = countRes?.results?.drafts
                            msEmails[i]['inbox'] = countRes?.results?.inbox
                            msEmails[i]['sent'] = countRes?.results?.sentitems
                            msEmails[i]['junk'] = countRes?.results?.junkemail
                        }

                    }).catch((err) => {
                        toast.show({
                            title: 'Warning',
                            description: 'Error Occured While Fetching Emails',
                        })
                    })

                }
            }
            if (googleEmails?.length > 0) {
                for (let i = 0; i < googleEmails?.length; i++) {
                    await dispatch(getEmailCountsForGoogle({ email: googleEmails[i]?.email, accessToken: googleEmails[i]?.accessToken, refreshToken: googleEmails[i]?.refreshToken, emailSyncDuration: googleEmails[i]?.emailSyncDuration })).then((res) => {
                        if (googleEmails[i]?.email === res?.email) {
                            googleEmails[i]['drafts'] = res?.results?.drafts
                            googleEmails[i]['inbox'] = res?.results?.inbox
                            googleEmails[i]['sent'] = res?.results?.sent
                            googleEmails[i]['junk'] = res?.results?.spam
                        }
                    }).catch((err) => {
                        toast.show({
                            title: 'Warning',
                            description: 'Error Occured While Fetching Emails',
                        })
                    })
                }
            }

            setUserEmails([...msEmails, ...googleEmails]) //all register emails
            setIsLoadingUserEmails(false)
            setSelectedUserEmail(res[0])
            setActiveEmail(res[0]?.id)
            setActiveSection('Inbox')

            setSelectedMailAndCategory({
                id: res[0]?.id,
                email: res[0]?.email,
                category: 'inbox',
                domain: res[0]?.domain
            })
            if (res.length === 0) {
                return
            }
            if (res[0]?.domain === 'microsoft') {
                onGetMicrosoftEmails(res[0]?.accessToken, res[0]?.email, null, null, res[0]?.emailSyncDuration)
            } else {
                onGetGoogleEmails(res[0]?.accessToken, res[0]?.refreshToken, res[0]?.email, null, null, res[0]?.emailSyncDuration)
                setPrevBtn(true)
                setNextBtn(false)
            }
        }).catch((err) => {
            setUserEmails([])
            setIsLoadingUserEmails(false)
            toast.show({
                title: 'Warning',
                description: 'Error Occured While Fetching User Emails',
            })
        })
    }, [])

    const filterRegisteredEmailDetails = () => {
        let details = userEmails.filter((userEmail) => userEmail.email.toLowerCase() === selectedMailAndCategory?.email?.toLowerCase())
        return details[0]
    }

    const onNextPage = async () => {
        let tmpNextPageToken = ''
        let registeredEmailDetail = filterRegisteredEmailDetails()
        if (registeredEmailDetail?.domain === "google") {
            tmpNextPageToken = emailSettings?.pagination[emailSettings?.currentPage - 1].nextPageToken
            if (tmpNextPageToken) {
                if (selectedMailAndCategory?.category === 'inbox') {
                    onGetGoogleEmails(registeredEmailDetail?.accessToken, registeredEmailDetail?.refreshToken, registeredEmailDetail?.email, tmpNextPageToken, 1, registeredEmailDetail?.emailSyncDuration)
                } else if (selectedMailAndCategory?.category === 'sent') {
                    await getSentEmailsFromGoogleHandler(registeredEmailDetail?.accessToken, registeredEmailDetail?.refreshToken, registeredEmailDetail?.email, tmpNextPageToken, 1, registeredEmailDetail?.emailSyncDuration)
                }
                setNextBtn(false)
            } else {
                setNextBtn(true)
            }
            if (emailSettings?.currentPage + 1 > 1) {
                setPrevBtn(false)
            }
        } else {
            tmpNextPageToken = emailSettings?.microsoftPagination[emailSettings?.microsoftCurrentPage - 1].nextPageToken
            if (tmpNextPageToken) {
                if (selectedMailAndCategory?.category === 'inbox') {
                    onGetMicrosoftEmails(registeredEmailDetail?.accessToken, registeredEmailDetail?.email, tmpNextPageToken, 1, registeredEmailDetail?.emailSyncDuration)
                } else if (selectedMailAndCategory?.category === 'sent') {
                    await getSentEmailsFromMicrosoftHandler(registeredEmailDetail?.accessToken, registeredEmailDetail?.email, tmpNextPageToken, 1, registeredEmailDetail?.emailSyncDuration)
                } else if (selectedMailAndCategory?.category === 'junks') {
                    await getJunkEmailsForMicrosoftHandler(registeredEmailDetail?.accessToken, registeredEmailDetail?.email, tmpNextPageToken, 1, registeredEmailDetail?.emailSyncDuration)
                    disablePageButtonHandler(1)
                }
            }
            if (emailSettings?.currentPage + 1 > 1) {
                setPrevBtn(false)
            }
        }
    }

    const onPreviousPage = async () => {
        let prevPageToken = ''
        let registeredEmailDetail = filterRegisteredEmailDetails()

        if (registeredEmailDetail?.domain === "google") {
            prevPageToken = emailSettings?.pagination[emailSettings?.currentPage - 1].prevPageToken
            if (!prevPageToken) {
                onGetGoogleEmails(registeredEmailDetail?.accessToken, registeredEmailDetail?.refreshToken, registeredEmailDetail?.email, prevPageToken, null, registeredEmailDetail?.emailSyncDuration)
                setPrevBtn(true)
            } else {
                onGetGoogleEmails(registeredEmailDetail?.accessToken, registeredEmailDetail?.refreshToken, registeredEmailDetail?.email, prevPageToken, -1, registeredEmailDetail?.emailSyncDuration)
                setPrevBtn(false)
            }
        } else {
            prevPageToken = emailSettings?.microsoftPagination[emailSettings?.microsoftCurrentPage - 2]?.prevPageToken

            if (prevPageToken) {
                if (selectedMailAndCategory?.category === 'inbox') {
                    onGetMicrosoftEmails(registeredEmailDetail?.accessToken, registeredEmailDetail?.email, prevPageToken, null, registeredEmailDetail?.emailSyncDuration)
                    disablePageButtonHandler(-1)
                } else if (selectedMailAndCategory?.category === 'sent') {
                    await getSentEmailsFromMicrosoftHandler(registeredEmailDetail?.accessToken, registeredEmailDetail?.email, prevPageToken, -1, registeredEmailDetail?.emailSyncDuration)
                    disablePageButtonHandler(-1)
                } else if (selectedMailAndCategory?.category === 'junks') {
                    await getJunkEmailsForMicrosoftHandler(registeredEmailDetail?.accessToken, registeredEmailDetail?.email, prevPageToken, -1, registeredEmailDetail?.emailSyncDuration)
                    disablePageButtonHandler(-1)
                }
            } else {
                if (selectedMailAndCategory?.category === 'inbox') {
                    onGetMicrosoftEmails(registeredEmailDetail?.accessToken, registeredEmailDetail?.email, null, null, registeredEmailDetail?.emailSyncDuration)
                } else if (selectedMailAndCategory?.category === 'sent') {
                    await getSentEmailsFromMicrosoftHandler(registeredEmailDetail?.accessToken, registeredEmailDetail?.email, prevPageToken, -1, registeredEmailDetail?.emailSyncDuration)
                } else if (selectedMailAndCategory?.category === 'junks') {
                    await getJunkEmailsForMicrosoftHandler(registeredEmailDetail?.accessToken, registeredEmailDetail?.email, prevPageToken, -1, registeredEmailDetail?.emailSyncDuration)
                }
                disablePageButtonHandler(-1)
            }
        }
    }

    const onDeleteHandler = () => {
        dispatch(deleteEmailFromTask({ emailConnectionId: selectedMailAndCategory?.id, domain: selectedMailAndCategory?.domain, supplierId: null, listSupplierId: null, emailId: emailIdToDelete, isOutboundEmail: selectedMailAndCategory?.category === 'sent' ? true : false, isOutboundEmailRead: selectedMailAndCategory?.category === 'sent' ? selectedFormatedEmail?.isRead ? true : false : null, isDelete: true })).then(() => {
            setShowDeleteModal(false)
            toast.show({
                title: 'Success',
                description: 'Email Deleted Successfully',
            })
        }).catch(() => {
            toast.show({
                title: 'Danger',
                description: 'Unable to delete email',
            })
        })
    }

    const getSentEmailsFromMicrosoftHandler = async (accessToken, email, pageLink = null, btn = null, emailSyncDuration) => {
        await dispatch(getSentEmailsFromMicrosoft({ accessToken: accessToken, email: email, pageLink: pageLink, btn: btn, emailSyncDuration })).then(async (res) => {
            // let tmpTrackingMessageIds = res?.emailList?.map((emailDetail) => emailDetail?.internetMessageHeaders?.[0]?.value)?.filter((data) => data !== undefined)
            // const allTrackingMessageIds = await dispatch(getTrackEmailMessageIds(tmpTrackingMessageIds)).then((res) => {
            //     return res
            // }).catch(err => {
            //     return res
            // })

            // let tmpData = res?.emailList?.map((emailData) => {
            //     let uuid = emailData?.internetMessageHeaders?.[0]?.value || ''
            //     let tmp = allTrackingMessageIds?.allMessageIds?.find((obj) => obj?.messageId === uuid)
            //     let tmpData = []
            //     if (uuid) {
            //         if (allTrackingMessageIds?.allMessageIds?.length === 0) {
            //             tmpData = [{ ...emailData, isOpen: false }]
            //         } else {
            //             let isExist = allTrackingMessageIds?.allMessageIds?.filter((track) => track?.messageId === uuid)
            //             tmpData = [{
            //                 ...emailData,
            //                 isOpen: isExist[0]?.isOpen
            //             }]

            //         }
            //     } else {
            //         tmpData = [{ ...emailData, isOpen: false }]
            //     }

            //     return tmpData[0]
            // })
            setIsLoading(false)
            setEmailList(res?.emailList)
        }).catch((err) => {
            setIsLoading(false)
            setEmailList([])
            if (err?.message?.code === "ENOTFOUND") {
                toast.show({
                    title: 'Warning',
                    description: 'Please Refresh And Try Again',
                })
            } else {
                toast.show({
                    title: 'Warning',
                    description: 'Error Occured While Fetching Emails',
                })
            }
        })
    }


    const getDraftEmailsFromMicrosoftHandler = async (accessToken, email, pageLink = null, btn = null, emailSyncDuration) => {
        await dispatch(getDraftEmailsForMicrosoft({ accessToken: accessToken, email: email, pageLink: pageLink, btn: btn, emailSyncDuration })).then((res) => {
            setIsLoading(false)
            setEmailList(res?.emailList)
        }).catch((err) => {
            setIsLoading(false)
            setEmailList([])
            toast.show({
                title: 'Warning',
                description: 'Error Occured While Fetching Emails',
            })
        })
    }

    const getSentEmailsFromGoogleHandler = async (accessToken, refreshToken, email, pageToken = null, btn = null, emailSyncDuration) => {
        await dispatch(getSentEmailsFromGoogle({ accessToken: accessToken, refreshToken: refreshToken, email: email, pageToken: pageToken, btn: btn, emailSyncDuration })).then(async (res) => {
            let emailDetails = []
            for (let i = 0; i < res?.emailList?.length; i++) {
                await dispatch(getEmailDetailsForThreadId({ accessToken: accessToken, messageIds: [res?.emailList[i]?.id], email: email, refreshToken: refreshToken, inChunks: false })).then(async (res) => {
                    // let messageID = res?.data?.payload?.headers?.filter((header) => header.name === "X-Custom-Header")[0]?.value?.split(":")[0]
                    // let trackEmail = await dispatch(getTrackEmailId({ messageId: messageID, domain: 'google' })).then((res) => res?.data?.results).catch((err) => err)
                    // let save
                    emailDetails.push(res?.data)
                }).catch(err => {
                    if (err?.data?.message === 'retry') {
                        toast.show({
                            title: 'Warning',
                            description: 'Please Check Your Internet Connectivity',
                        })

                    } else {
                        toast.show({
                            title: 'Warning',
                            description: 'Error Occured While Fetching Emails',
                        })
                    }
                })
            }
            setIsLoading(false)
            setEmailList(emailDetails)
        }).catch((err) => {
            setIsLoading(false)
            toast.show({
                title: 'Warning',
                description: 'Error Occured While Fetching Emails',
            })
        })
    }


    const getDraftEmailsFromGoogleHandler = async (accessToken, refreshToken, email, pageToken = null, btn = null, emailSyncDuration) => {
        await dispatch(getDraftEmailsFromGoogle({ accessToken: accessToken, refreshToken: refreshToken, email: email, pageToken: pageToken, btn: btn, emailSyncDuration })).then(async (res) => {
            let emailDetails = []
            for (let i = 0; i < res?.messages?.length; i++) {
                await dispatch(getEmailDetailsForThreadId({ accessToken: accessToken, messageIds: [res?.messages[i]?.id], inChunks: false })).then((res) => {
                    emailDetails.push(res?.data)
                }).catch(err => {
                    toast.show({
                        title: 'Warning',
                        description: 'Error Occured While Fetching Emails',
                    })
                })
            }
            setIsLoading(false)
            setEmailList(emailDetails)
        }).catch((err) => {
            setIsLoading(false)
            toast.show({
                title: 'Warning',
                description: 'Error Occured While Fetching Emails',
            })
        })
    }



    const getJunkEmailsForMicrosoftHandler = async (accessToken, email, pageLink = null, btn = null, emailSyncDuration) => {
        await dispatch(getJunkEmailsForMicrosoft({ accessToken: accessToken, email: email, pageLink: pageLink, btn: btn, emailSyncDuration })).then((res) => {
            setTotalJunksRecords(res?.totalCount)
            setEmailList(res?.emailList)
            setIsLoading(false)
        }).catch((err) => {
            setEmailList([])
            setIsLoading(false)
            toast.show({
                title: 'Warning',
                description: 'Error Occured While Fetching Junk Emails',
            })
        })
    }

    const getSpamEmailsFromGoogleHandler = async (accessToken, refreshToken, email, pageToken = null, emailSyncDuration) => {
        await dispatch(getSpamEmailsFromGoogle({ accessToken: accessToken, refreshToken: refreshToken, email: email, pageToken, emailSyncDuration })).then(async (res) => {
            let emailDetails = []
            for (let i = 0; i < res?.messages?.length; i++) {
                await dispatch(getEmailDetailsForThreadId({ accessToken: accessToken, messageIds: [res?.messages[i]?.id], email: email, refreshToken: refreshToken, inChunks: false })).then((res) => {
                    emailDetails.push(res?.data)
                }).catch((err) => {
                    toast.show({
                        title: 'Warning',
                        description: 'Error Occured While Fetching Junk Emails',
                    })
                })
            }

            setIsLoading(false)
            setEmailList(emailDetails)
        }).catch((err) => {
            setEmailList([])
            setIsLoading(false)
            toast.show({
                title: 'Warning',
                description: 'Error Occured While Fetching Junk Emails',
            })
        })
    }

    const disablePageButtonHandler = (btn) => {
        if (btn === 1) {
            let tmpNextPageToken = emailSettings?.microsoftPagination[emailSettings?.microsoftCurrentPage - 1]?.nextPageToken
            if (!tmpNextPageToken) {
                setNextBtn(true)
            } else {
                setNextBtn(false)
            }
        } else if (btn === -1) {
            let prevPageToken = emailSettings?.pagination[emailSettings?.currentPage - 2]?.prevPageToken
            let nextPageToken = emailSettings?.pagination[emailSettings?.currentPage - 2]?.nextPageToken

            !prevPageToken ? setPrevBtn(true) : setPrevBtn(false)
            !nextPageToken ? setNextBtn(true) : setNextBtn(false)
        }
    }


    const onSideBarHandler = async (email, menu, domain, isBackBtnPressed = false) => {
        setSelectedMailAndCategory({
            email: email,
            category: isBackBtnPressed ? menu : menu?.id,
            domain: domain
        })
        setEmailList([])
        setIsLoading(true)

        let findRegisteredEmail = userEmails?.filter((emailData) => {
            if (emailData?.email === email) {
                return emailData
            }
        })
        if (menu?.id === 'inbox' || (isBackBtnPressed && menu === 'inbox')) {
            if (findRegisteredEmail[0]?.domain === "microsoft") {
                await onGetMicrosoftEmails(findRegisteredEmail[0]?.accessToken, email, null, null, findRegisteredEmail[0]?.emailSyncDuration)
            } else {
                await onGetGoogleEmails(findRegisteredEmail[0]?.accessToken, findRegisteredEmail[0]?.refreshToken, email, null, null, findRegisteredEmail[0]?.emailSyncDuration)
            }
        } else if (menu?.id === 'sent' || (isBackBtnPressed && menu === 'sent')) {
            if (findRegisteredEmail[0]?.domain === "microsoft") {
                await getSentEmailsFromMicrosoftHandler(findRegisteredEmail[0]?.accessToken, email, null, null, findRegisteredEmail[0]?.emailSyncDuration)
            } else {
                await getSentEmailsFromGoogleHandler(findRegisteredEmail[0]?.accessToken, findRegisteredEmail[0]?.refreshToken, email, null, null, findRegisteredEmail[0]?.emailSyncDuration)
            }
        } else if (menu?.id === 'junk' || (isBackBtnPressed && menu === 'junk')) {
            if (findRegisteredEmail[0]?.domain === "microsoft") {
                await getJunkEmailsForMicrosoftHandler(findRegisteredEmail[0]?.accessToken, email, null, null, findRegisteredEmail[0]?.emailSyncDuration)
                disablePageButtonHandler(1)
            } else {
                await getSpamEmailsFromGoogleHandler(findRegisteredEmail[0]?.accessToken, findRegisteredEmail[0]?.refreshToken, email, null, findRegisteredEmail[0]?.emailSyncDuration)
            }
        } else if (menu?.id === 'drafts' || (isBackBtnPressed && menu === 'drafts')) {
            if (findRegisteredEmail[0]?.domain === "microsoft") {
                await getDraftEmailsFromMicrosoftHandler(findRegisteredEmail[0]?.accessToken, email, null, null, findRegisteredEmail[0]?.emailSyncDuration)
            } else {
                await getDraftEmailsFromGoogleHandler(findRegisteredEmail[0]?.accessToken, findRegisteredEmail[0]?.refreshToken, email, null, findRegisteredEmail[0]?.emailSyncDuration)
            }
        }

        setCurrentPage("emails")
        setActiveSection(menu)
        setActiveEmail(null)
    }

    const onGoBack = () => {
        onSideBarHandler(selectedMailAndCategory?.email, selectedMailAndCategory?.category, selectedMailAndCategory?.domain, true)
    }

    const showEmailComposeModalHandler = (emailId, action) => {
        setAction(action)
        let tmpSelectedEmail = formattedEmailList?.filter(email => email?.messageId === emailId)[0]
        setSelectedFormatedEmail(tmpSelectedEmail)
        setShowEmailComposeModal(true)
        setForwardOrReplyEmailId(emailId)
    }

    useEffect(() => {
        let cancelled = false
        getEmailsForUser(cancelled)
        return () => {
            cancelled = true
        }
    }, [tab])

    useEffect(() => {
        let tmpFormatedEmails = []
        for (let index = 0; index < emailList?.length; index++) {
            const emailHistory = emailList[index];

            let tmpFormattedHistory = convertEmailHistoryStructure(selectedMailAndCategory?.domain, null, emailHistory, userEmails)
            tmpFormatedEmails.push(tmpFormattedHistory)
        }
        setFormattedEmailList(tmpFormatedEmails)
    }, [emailList])

    useEffect(() => {
        if (selectedMailAndCategory?.category === 'inbox' || selectedMailAndCategory?.category === 'junk') {
            onSideBarHandler(selectedMailAndCategory?.email, selectedMailAndCategory?.category, selectedMailAndCategory?.domain, true)
        }

    }, [unreadEmails])

    return (
        <div className=" h-100">
            {!noRegEmailModal ? <div className={`${(tab === 'notifications' || currentPage === 'notification-email') ? '  mt-3' : ''}`} style={{ height: '85%' }}>
                {tab === 'emails' && <div className={`d-flex h-100 column-gap-2`}>
                    <div className={` h-100 p-3 d-flex row-gap-3 flex-column rounded ${isLoadingUserEmails ? ' loading' : ''}`} style={{ backgroundColor: '#F6F8FC', width: 300 }}>
                        {
                            isLoadingUserEmails ? <div className="h-100 d-flex justify-content-center align-items-center"><Loader /></div> : (userEmails.map(email => {
                                return (
                                    <Accordion
                                        email={email}
                                        sideBar={sideBar}
                                        onSideBarHandler={onSideBarHandler}
                                        selectedMailAndCategory={selectedMailAndCategory}
                                        setSelectedMailAndCategory={setSelectedMailAndCategory}
                                    />
                                )
                            })
                            )
                        }

                    </div>
                    <div className={`col-10  w-75  h-100 p-0 ${(currentPage !== 'emailDetail' && currentPage !== 'draftEmail') ? '' : ''}`} >
                        {currentPage !== 'emailDetail' && (
                            <div className="d-flex justify-content-between align-items-center">
                                <h4 className="fw-bold px-5 py-3 mx-4 text-black">{currentPage === 'emails' ? 'Messages' : currentPage === 'sent' ? 'Sent Messages' : 'Drafts'}</h4>
                            </div>)}

                        {currentPage === 'emailDetail' && (
                            <div className=" d-flex column-gap-5 px-5 py-0 mx-4">
                                <button onClick={() => { onGoBack() }}><IoMdArrowRoundBack size={27} /></button>
                                {emailButtons.map((btn) => <button><img src={btn.value} /></button>)}
                            </div>
                        )}

                        {
                            <Modal
                                backdrop='static'
                                className="advance-acceptance-details-modal"
                                show={showDeleteModal}
                                size="md"
                                onClick={() => { setShowDeleteModal(true) }}
                                onHide={() => { setShowDeleteModal(false) }}
                            >
                                <Modal.Header>
                                    <Modal.Title className='text-danger fw-bold h3'>
                                        Warning
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="d-flex flex-column">
                                    <p className="fw-bold fs-3"> Do you want to delete this email?</p>
                                    <span className="fs-4"><span>Note: </span>This email will not be not shown in app but will be available in you email system</span>
                                </Modal.Body>
                                <Modal.Footer className="d-flex justify-content-end column-gap-3">
                                    <button className="report_small_button_grey" onClick={() => { setShowDeleteModal(false) }}>Cancel</button>
                                    <button className="report_small_button_danger" onClick={() => { onDeleteHandler() }}>Delete</button>
                                </Modal.Footer>
                            </Modal>
                        }

                        {
                            showEmailComposeModal && (
                                <Modal
                                    backdrop='static'
                                    className="advance-acceptance-details-modal"
                                    show={showEmailComposeModal}
                                    size="md"
                                    onClick={() => { setShowEmailComposeModal(true) }}
                                    onHide={() => { setShowEmailComposeModal(false) }}
                                >
                                    <Modal.Header>
                                        <Modal.Title className='text-danger fw-bold h3'>

                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="d-flex flex-column">
                                        <ComposeEmail
                                            componentFor={'tasks'}
                                            supplierInfo={{}}
                                            vendorInfo={{}}
                                            contactOptions={[]}
                                            onGetExistingContacts={() => { }}
                                            vendorInCallDetailsId={null}
                                            contacts={[]}
                                            getContactsData={() => { }}
                                            activeTab={''}
                                            actionOnEmailForTask={action}
                                            forwardOrReplyEmailId={forwardOrReplyEmailId}
                                            selectedFormatedEmail={selectedFormatedEmail}
                                            setShow={setShowEmailComposeModal}
                                        />
                                    </Modal.Body>
                                    <Modal.Footer className="d-flex justify-content-end column-gap-3">

                                    </Modal.Footer>
                                </Modal>
                            )
                        }

                        {(currentPage !== 'emailDetail' && currentPage !== 'draftEmail') && <div className={`record-body border  d-flex flex-column justify-content-between  position-relative${isLoading ? ' loading' : ''} mt-4`} style={{ height: '80%' }}>
                            {isLoading && <LoaderComponent />}

                            <Table
                                virtualized
                                autoHeight
                                affixHeader={true}
                                data={formattedEmailList || []}
                                flexGrow={1}
                            >
                                <Column width={30} align="center" >
                                    <HeaderCell ></HeaderCell>
                                    <Cell />
                                </Column>
                                <Column width={50} align="center" >
                                    <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', display: 'none', }}>
                                        <Checkbox
                                            checked={checked}
                                            indeterminate={indeterminate}
                                            onChange={handleCheckAll}
                                        />
                                    </HeaderCell>
                                    <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} />
                                </Column>
                                {headerColumns()}
                                {(selectedMailAndCategory?.category === "sent" || selectedMailAndCategory?.category === "inbox") && <Column
                                    width={100}
                                    fixed='right'
                                    align="center"
                                >
                                    <HeaderCell className='text-black fw-bold '>Email Opened</HeaderCell>
                                    <ActionCell
                                        dataKey='isRead'
                                        currentPage={currentPage}
                                        selectedMailAndCategory={selectedMailAndCategory}

                                    />
                                </Column>}
                                {(selectedMailAndCategory?.category === "sent") && <Column
                                    width={80}
                                    fixed='right'
                                    align="center"
                                >
                                    <HeaderCell className='text-black fw-bold'>Link Opened</HeaderCell>
                                    <ActionCell
                                        dataKey='isOpen'
                                        currentPage={currentPage}
                                    />
                                </Column>}
                                {(selectedMailAndCategory?.category !== "draft") && <Column
                                    width={80}
                                    fixed='right'
                                    align="center"
                                >
                                    <HeaderCell className='text-black fw-bold'>Forward</HeaderCell>
                                    <ActionCell
                                        dataKey='forward'
                                        currentPage={currentPage}
                                        actionHandler={showEmailComposeModalHandler}
                                    />
                                </Column>}
                                {(selectedMailAndCategory?.category !== "draft  ") && <Column
                                    width={70}
                                    fixed='right'
                                    align="center"
                                >
                                    <HeaderCell className='text-black fw-bold'>Reply</HeaderCell>
                                    <ActionCell
                                        dataKey='reply'
                                        currentPage={currentPage}
                                        actionHandler={showEmailComposeModalHandler}
                                    />
                                </Column>}
                            </Table>
                            {formattedEmailList?.length !== 0 && <div className="pagination d-flex justify-content-end  column-gap-3 py-3 pe-3">
                                <button className="btn btn-primary" onClick={onPreviousPage} disabled={prevbtn} >Previous</button>
                                <button className="btn btn-primary" onClick={onNextPage} disabled={nextBtn} >Nexts</button>
                            </div>}
                        </div>}
                        {currentPage === 'emailDetail' && (
                            <EmailDetail
                                hrLine={false}
                                selectedEmail={selectedEmail}
                                selectedMailAndCategory={selectedMailAndCategory}
                                userEmails={userEmails}
                                tab={tab}
                            />
                        )}
                        {currentPage === 'draftEmail' && <EmailDraft />}
                    </div>
                </div>}
                {/* {(tab === 'notification' && currentPage !== 'notification-email') && <Notification onPageChange={onPageChange} tab={tab} />} */}
            </div> : <div className="d-flex justify-content-center align-items-center mt-5">
                <p className="fw-bold fs-4" style={{ color: '#214466' }}>You have not registered your email yet!</p>
            </div>}
        </div>
    )
}

export default Emails